import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetOwnedRecipesBoardsQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

export const useRecipesBoardId = () => {
  const { recipesBoardId: routeRecipesBoardId } = useParams();
  const lastUsedRecipesBoardId = useSelector(
    (state) => state.recipes.currentRecipesBoardId,
  );

  const { data: ownedRecipesBoards, isLoading: isOwnedRecipesBoardsLoading } =
    useGetOwnedRecipesBoardsQuery();

  const firstBoard = !isOwnedRecipesBoardsLoading && ownedRecipesBoards[0];

  return routeRecipesBoardId || lastUsedRecipesBoardId || firstBoard?.id;
};
